// A register's "history window": the last 90 days by default, the whole
// history on the All-history toggle, and an explicit OLDER From date widens
// the window so the client-side date filter never shows empty for want of
// unloaded rows. The Deliveries board's cutoffIso / serverFromIso rule
// (mirrored by BlueberryDeliveries), extracted when the Receive-pallets
// register became the third copy. Pure, so the sibling test pins it;
// useHistoryWindow is the React wrapper.
export const HISTORY_WINDOW_DAYS = 90

/** ISO instant for "the last 90 days" as of `now`. */
export function historyCutoffIso(now: Date = new Date()): string {
  const d = new Date(now); d.setDate(d.getDate() - HISTORY_WINDOW_DAYS)
  return d.toISOString()
}

/**
 * What the SERVER should send: null = everything, else rows received on or
 * after this instant. `fromFilter` is the operator's From date (YYYY-MM-DD,
 * '' = unset); it parses in local time exactly as the board does.
 */
export function serverWindowFrom(showAllHistory: boolean, fromFilter: string, cutoffIso: string): string | null {
  if (showAllHistory) return null
  if (fromFilter) {
    const f = new Date(`${fromFilter}T00:00:00`).toISOString()
    return f < cutoffIso ? f : cutoffIso
  }
  return cutoffIso
}
